module.exports = __webpack_public_path__ + "img/shipo-menu-sales-plan.c778ebcf.svg";